import { render, staticRenderFns } from "./TelnyxBalance.vue?vue&type=template&id=1111a505&scoped=true"
import script from "./TelnyxBalance.vue?vue&type=script&lang=js"
export * from "./TelnyxBalance.vue?vue&type=script&lang=js"
import style0 from "./TelnyxBalance.vue?vue&type=style&index=0&id=1111a505&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1111a505",
  null
  
)

export default component.exports